/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoAnalyticsModelsWidgetListItem
 */
export interface IdentityMelcoAnalyticsModelsWidgetListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoAnalyticsModelsWidgetListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoAnalyticsModelsWidgetListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoAnalyticsModelsWidgetListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoAnalyticsModelsWidgetListItem
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoAnalyticsModelsWidgetListItem
     */
    url?: string | null;
}

export function IdentityMelcoAnalyticsModelsWidgetListItemFromJSON(json: any): IdentityMelcoAnalyticsModelsWidgetListItem {
    return IdentityMelcoAnalyticsModelsWidgetListItemFromJSONTyped(json, false);
}

export function IdentityMelcoAnalyticsModelsWidgetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoAnalyticsModelsWidgetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function IdentityMelcoAnalyticsModelsWidgetListItemToJSON(value?: IdentityMelcoAnalyticsModelsWidgetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'type': value.type,
        'url': value.url,
    };
}


